import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export interface WorkOSProfile {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  emailVerified: boolean;
  profilePictureUrl?: string;
}

export interface WorkOSAuthorizationResponse {
  success: boolean;
  authorizationUrl: string;
}

export const workosService = {
  /**
   * Get the WorkOS authorization URL from the backend
   * @param organization - Optional organization identifier
   * @returns The authorization URL to redirect the user to
   */
  getAuthorizationUrl: async (organization?: string): Promise<string> => {
    try {
      const params = organization ? { organization } : {};
      const response = await axios.get<WorkOSAuthorizationResponse>(
        `${API_URL}/auth/workos/authorize`,
        { params }
      );
      
      if (response.data.success && response.data.authorizationUrl) {
        return response.data.authorizationUrl;
      }
      
      throw new Error('Failed to get authorization URL');
    } catch (error: any) {
      console.error('Error getting WorkOS authorization URL:', error);
      throw new Error(
        error.response?.data?.message || 
        'Failed to initialize SSO authentication'
      );
    }
  },

  /**
   * Get the WorkOS user profile using the token
   * @param token - The authentication token
   * @returns The user profile from WorkOS
   */
  getProfile: async (token: string): Promise<WorkOSProfile> => {
    try {
      const response = await axios.get<WorkOSProfile>(
        `${API_URL}/auth/workos/profile`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      return response.data;
    } catch (error: any) {
      console.error('Error getting WorkOS profile:', error);
      throw new Error(
        error.response?.data?.message || 
        'Failed to get user profile'
      );
    }
  },
};

